<div>
  <mat-label>{{title}}</mat-label>
</div><br>
<form #form="ngForm">
  <div *ngIf="shubetsu === 'bikou'">
    <mat-form-field class="input-margin" style="width: 200px">
      <mat-label>
        備考
      </mat-label>
      <textarea matInput placeholder="備考" rows="1"
        name="bikou" [(ngModel)]="meisai.bikou"></textarea>
    </mat-form-field>
    <mat-form-field class="input-margin" style="width: 200px">
      <mat-label>
        1セルあたりの羽数
      </mat-label>
      <input matInput placeholder="1セルあたりの羽数" type="text" inputmode="numeric" step="1" min="0"
             name="cellWasuu" [(ngModel)]="meisai.cellWasuu" #cellWasuuModel="ngModel"
             [errorStateMatcher]="wasuuErrorStateMatcher" integerOnly>
      <mat-error *ngIf="cellWasuuModel.hasError('integerOnly')">羽数は整数で入力してください。</mat-error>
    </mat-form-field>
  </div>
  <div *ngIf="shubetsu === 'gridTile'">
    <mat-form-field class="input-margin">
      <mat-label>
        テキスト
      </mat-label>
      <textarea matInput rows="5"
                name="grid-text" [(ngModel)]="meisai.text"></textarea>
    </mat-form-field>
  </div>

</form>
<div mat-dialog-actions align="end">
  <button mat-button mat-flat-button color="primary"
          (click)="commonService.onClick(this.matDialogRef, meisai)"
          [disabled]="form.invalid">
    <span>Enter</span>
  </button>
</div>
